import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { lessonActions } from '../actions/lesson.actions';
import { selectLesson, selectLoaded, selectLoading } from '../selectors/lesson.selector';

@Injectable({
    providedIn: 'root',
})
export class LessonFacade {
    private store = inject(Store);

    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly lesson$ = (id: string) => this.store.select(selectLesson(id));
    readonly lessonNonNullable$ = (id: string) => this.store.select(selectLesson(id)).pipe(filter((data) => data !== null));

    getLesson = (id: string): void => this.store.dispatch(lessonActions.getLesson({ id }));

    clear(): void {
        this.store.dispatch(lessonActions.clear());
    }
}
